import * as feathers from '@feathersjs/client';
import * as feathersRx from 'feathers-reactive/dist/feathers-reactive.js';
import reduxifyServices from 'feathers-redux';
import reduxifyAuthentication from 'feathers-reduxify-authentication';
import io from 'socket.io-client';
window.socket = io(process.env.SERVER_MAIN_URL, {
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 15000,
});
var fClient = feathers()
    .configure(feathers.socketio(window.socket))
    .configure(feathers.authentication({
    cookie: 'crimp-jwt',
    storageKey: 'crimp-jwt',
    storage: window.localStorage,
}))
    .configure(feathersRx({
    idField: 'id',
}));
export default fClient;
export var feathersServices = reduxifyServices(fClient, [
    'users',
    'userProfiles',
    'userOrganizationRoles',
    'userEventRoles',
    'organizations',
    'events',
    'categories',
    'rounds',
    'roundBibs',
    'routes',
    'teams',
    'teamScores',
    'athletes',
    'athleteScores',
    'athleteScoreRoutes',
    'athleteScoreRouteHistories',
    'actives',
    'notifications',
]);
export var feathersAuthentication = reduxifyAuthentication(fClient);



//////////////////
// WEBPACK FOOTER
// ./src/feathers/index.ts
// module id = 17
// module chunks = 0